import _mock from './_mock';

// ----------------------------------------------------------------------

export * from './_app';
export * from './_user';
export * from './_others';
export * from './_motherTongue';
export * from './_mstatus';
export * from './_countries';
export default _mock;
